import { NAVIGATION_DESIGN_TYPE, NAVIGATION_POSITION_TYPE, NAVIGATION_SIZE_TYPE, NAVIGATION_THEME_TYPE, NAVIGATION_TYPE } from "src/libs/useful/gallery/Gallery"
import CarouselDesignHandler from "./CarouselDesignHandler"
import NavDesignHandler from "./NavDesignHandler"
import NavSizeHandler from "./NavSizeHandler"
import NavThemeHandler from "./NavThemeHandler"
import NavTypeHandler from "./NavTypeHandler"
import "./style.scss"


/* Protopia Ecosystem component */
export interface ICarouselNavigation {
    carousel_nav_position: NAVIGATION_POSITION_TYPE
    carousel_nav: NAVIGATION_TYPE
    carousel_nav_theme: NAVIGATION_THEME_TYPE
    carousel_nav_type: NAVIGATION_DESIGN_TYPE
    carousel_nav_size: NAVIGATION_SIZE_TYPE
}

export const NAV_THEMES: any = {
    [NAVIGATION_THEME_TYPE.DEFAULT]: "var(--force-contrast-opacity-color)",
    [NAVIGATION_THEME_TYPE.DARK]:   "var(--force-contast-color)",
    [NAVIGATION_THEME_TYPE.GREEN]:  "var(--success)",
    [NAVIGATION_THEME_TYPE.LIGHT]:  "var(--force-plain-color)",
    [NAVIGATION_THEME_TYPE.RED]:    "var(--danger)",
}

export interface ICWProps extends ICarouselNavigation { 
   onChange: ( data: ICarouselNavigation ) => void
}
const CW = (props: ICWProps): JSX.Element => {

    const onPosition = (pos: NAVIGATION_POSITION_TYPE) => {
        props.onChange({
            ...props,
            carousel_nav_position: pos
        })
    }
    const onChange = (value: ICarouselNavigation) => {
        props.onChange({ ...props, ...value })
    }

    return <div className='pe-cw-container'>

        <div className="carousel-frame"></div>
        
        {/* top navigation */}
        <div className="carousel-top-left-pos carousel-place" onClick={() => onPosition( NAVIGATION_POSITION_TYPE.TOP_LEFT )}></div>
        <div className="carousel-top-center-pos carousel-place" onClick={() => onPosition( NAVIGATION_POSITION_TYPE.TOP_CENTER )}></div>
        <div className="carousel-top-right-pos carousel-place" onClick={() => onPosition( NAVIGATION_POSITION_TYPE.TOP_RIGHT )}></div>
        
        {/* center outer navigation */}
        <div className="carousel-middle-outer-left-pos carousel-place" onClick={() => onPosition( NAVIGATION_POSITION_TYPE.MIDDLE_OUTER )}></div>
        <div className="carousel-middle-outer-right-pos carousel-place" onClick={() => onPosition( NAVIGATION_POSITION_TYPE.MIDDLE_OUTER )}></div>

        {/* center inner navigation */}
        <div className="carousel-middle-inner-left-pos carousel-place" onClick={() => onPosition( NAVIGATION_POSITION_TYPE.MIDDLE_INNER )}></div>
        <div className="carousel-middle-inner-right-pos carousel-place" onClick={() => onPosition( NAVIGATION_POSITION_TYPE.MIDDLE_INNER )}></div>

        <CarouselDesignHandler 
            { ...props }
            carousel_nav_position={ props.carousel_nav_position || NAVIGATION_POSITION_TYPE.TOP_RIGHT}
        />
        <div className="pt-2 d-flex justify-content-center align-items-center position-absolute bottom left w-100">
            <NavDesignHandler {...props} onChange={onChange} /> 
            <NavThemeHandler  {...props} onChange={onChange} />
            <NavSizeHandler   {...props} onChange={onChange} />
            <NavTypeHandler   {...props} onChange={onChange} />
        </div>
    </div>
}
export default CW